var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
var configURL = {
    jwttokenfornesttraderUrl: config.web_mw + "Account/jwttokenfornesttrader",
    retriveAccountData: config.jmw + config.jmw_content + "adhoc/retrieve/data",
    retrieveExtPlatAccData: config.jmw + config.jmw_login + "accounts/logindata/web",
};
var commonUrlConfig = __assign(__assign({}, configURL), { jwttokenfornesttraderUrl: config.web_mw + "Account/jwttokenfornesttrader" });
export default commonUrlConfig;
